import React from "react";
import Navbar from "../nav/Navbar";
import styled from "@emotion/styled";

const Wrapper = styled.div`
  @media print {
    color-adjust: exact;
  }
`;

interface IProps {
  children: React.ReactNode;
}

const DefaultLayout = ({ children }: IProps) => {
  return (
    <Wrapper>
      <Navbar />
      {children}
    </Wrapper>
  );
};

export default DefaultLayout;
